export default __webpack_public_path__ + "static/media/dubai.b5ad66a0.jpg";